//
//
//
//

import Vue from 'vue';

export default Vue.extend({
  name: 'app',
  meta() {
    return {
      title: 'Home',
      titleTemplate: title => `${title} - Core CM Reports`,
    };
  },
});
